<elder-nav-list class="flex">
  <elder-nav-link
    icon="dashboard"
    title="context.dashboard"
    routerLink="app/dashboard"
  ></elder-nav-link>
  <elder-nav-link
    icon="linear_scale"
    title="manufacturing.lines.title"
    routerLink="app/production-lines"
  ></elder-nav-link>
  <elder-nav-link
    icon="poll"
    title="manufacturing.scheduling.title"
    routerLink="app/scheduling"
  ></elder-nav-link>

  <mat-divider></mat-divider>

  <elder-nav-link
    icon="description"
    title="orders.prod.title"
    routerLink="app/prod-orders"
  ></elder-nav-link>
  <elder-nav-link
    icon="description"
    title="orders.work.title"
    routerLink="app/work-orders"
  ></elder-nav-link>

  <mat-divider></mat-divider>

  <elder-nav-group>
    <mat-icon>view_compact</mat-icon>
    <span>{{ 'shopfloor.title' | translate }}</span>
    <elder-nav-link
      icon="blur_linear"
      title="shopfloor.layout.title"
      routerLink="app/shop-floor/layout"
      queryParamsHandling="merge"
    ></elder-nav-link>
    <!-- TODO improve queryParamsHandling -->
    <elder-nav-link
      icon="work"
      title="shopfloor.workcenters.title"
      routerLink="app/shop-floor/work-centers"
    ></elder-nav-link>
    <elder-nav-link
      icon="build"
      title="shopfloor.workstations.title"
      routerLink="app/shop-floor/work-stations"
    ></elder-nav-link>
    <elder-nav-link
      icon="control_camera"
      title="shopfloor.controlcenters.title"
      routerLink="app/shop-floor/control-centers"
    ></elder-nav-link>
    <elder-nav-link
      icon="border_all"
      title="shopfloor.storage.title"
      href="{{ storageManagementUrl() }}"
    ></elder-nav-link>
  </elder-nav-group>

  <elder-nav-group>
    <mat-icon>account_tree</mat-icon>
    <span>{{ 'process.title' | translate }}</span>
    <elder-nav-link
      icon="account_tree"
      title="process.plans.title"
      routerLink="app/process/plans"
    ></elder-nav-link>
    <elder-nav-link
      icon="build"
      title="process.actions.title"
      routerLink="app/process/actions"
    ></elder-nav-link>
  </elder-nav-group>

  <mat-divider></mat-divider>

  <elder-nav-link
    icon="assignment"
    title="orders.prod.list.title"
    routerLink="app/production-list"
  ></elder-nav-link>

  <elder-nav-link icon="assessment" title="reports.title" routerLink="app/reports"></elder-nav-link>

  <mat-divider></mat-divider>

  @if (isPrincipalSiteManager()) {
    <elder-nav-link icon="assignment" title="jobs.title" routerLink="app/jobs"></elder-nav-link>
  }

  <elder-nav-group>
    <mat-icon>settings</mat-icon>
    <span>{{ 'settings.title' | translate }}</span>
    <elder-nav-link
      icon="home"
      title="settings.local"
      routerLink="app/settings/local"
    ></elder-nav-link>
    <elder-nav-link
      icon="label"
      title="properties.title"
      routerLink="app/settings/properties"
    ></elder-nav-link>
    <elder-nav-link
      icon="fitness_center"
      title="capabilities.capabilities"
      routerLink="app/settings/capabilities"
    ></elder-nav-link>
    <elder-nav-link
      icon="work"
      title="shopfloor.workcenters.types.types"
      routerLink="app/settings/workcenter-types"
    ></elder-nav-link>
    <elder-nav-link
      icon="build"
      title="shopfloor.workstations.types.types"
      routerLink="app/settings/workstation-types"
    ></elder-nav-link>
    <elder-nav-link
      icon="featured_video"
      title="packages.types.types"
      routerLink="app/settings/package-types"
    ></elder-nav-link>
    <elder-nav-link
      icon="123"
      title="numberSequences.title"
      routerLink="app/settings/number-sequences"
    ></elder-nav-link>
    <elder-nav-link
      icon="calendar_month"
      title="schedules.workSchedules"
      routerLink="app/settings/work-schedules"
    ></elder-nav-link>
    <elder-nav-link
      icon="show_chart"
      title="optimization.title"
      routerLink="app/settings/optimization"
    ></elder-nav-link>
    <elder-nav-link
      icon="info"
      title="production_codes.title"
      routerLink="app/settings/production-codes"
    ></elder-nav-link>
    <elder-nav-link
      icon="assignment"
      title="orders.prod.list.lists"
      routerLink="app/settings/production-lists"
    ></elder-nav-link>
    <elder-nav-link
      icon="layers"
      title="materials.title"
      routerLink="app/settings/materials"
    ></elder-nav-link>
    <elder-nav-link
      icon="storefront"
      title="manufacturer.title"
      routerLink="app/settings/vendors"
    ></elder-nav-link>
    <elder-nav-link
      icon="qr_code_2"
      title="batchtracing.title"
      routerLink="app/settings/batch-tracing"
    ></elder-nav-link>
    @if (isPrincipalOwner()) {
      <elder-nav-link
        icon="keyboard_command_key"
        title="commands.title"
        routerLink="app/settings/commands"
      ></elder-nav-link>
    }
  </elder-nav-group>
</elder-nav-list>
